import React, {useState} from 'react'
import "./Navbar.scss";
import openNav from '../assets/open_nav.svg'
import closeNav from '../assets/close_nav.svg'

const Navbar = () => {

  const [showNav, setShowNav] = useState(false)

  const navButtonToggler = () => setShowNav(showNav => !showNav)

  return (
    <div>
        <div className="navbar_container">
            <div className="logo frankie">
                Saif Khan
            </div>
            <div className="nav_buttons_cont">
              {
                showNav ? <img onClick={navButtonToggler} className='open_nav' src={closeNav} alt="" /> : <img onClick={navButtonToggler} className='close_nav' src={openNav} alt="" />
              }  
            </div>
            <div className={`nav_items_container ${showNav ? 'left' : ''}`}>
                <div onClick={navButtonToggler} className="nav_item"> <a href="#home">Home</a> </div>
                <div onClick={navButtonToggler} className="nav_item"> <a href="#Aboutme">About</a> </div>
                <div onClick={navButtonToggler} className="nav_item"> <a href="#MySkills">Skills</a> </div>
                <div onClick={navButtonToggler} className="nav_item"> <a href="#Projects">Projects</a> </div>
                <div onClick={navButtonToggler} className="nav_item"> <a href="#GetInTouch">Contact</a> </div>
            </div>
        </div>
    </div>
  )
}

export default Navbar